import { useState } from 'react'
import { 
  ChevronRight, 
  Settings, 
  Bell, 
  Shield, 
  HelpCircle, 
  LogOut, 
  Edit3,
  Moon,
  Globe,
  Smartphone,
  CreditCard
} from 'lucide-react'
import UserCard from '../components/UserCard'

// 设置菜单数据
const settingsMenu = [
  {
    id: 'notifications',
    icon: Bell,
    label: '通知设置',
    value: '已开启',
  },
  {
    id: 'privacy',
    icon: Shield,
    label: '隐私安全',
    value: '',
  },
  {
    id: 'appearance',
    icon: Moon,
    label: '外观主题',
    value: '深色模式',
  },
  {
    id: 'language',
    icon: Globe,
    label: '语言设置',
    value: '简体中文',
  },
  {
    id: 'devices',
    icon: Smartphone,
    label: '设备管理',
    value: '3台设备',
  },
  {
    id: 'payment',
    icon: CreditCard,
    label: '支付设置',
    value: '',
  },
]

// 其他选项
const otherOptions = [
  {
    id: 'help',
    icon: HelpCircle,
    label: '帮助中心',
  },
  {
    id: 'settings',
    icon: Settings,
    label: '系统设置',
  },
]

export default function Profile() {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)

  return (
    <div className="animate-fade-in">
      {/* 用户信息卡片 */}
      <UserCard />

      {/* 编辑资料按钮 */}
      <div className="px-4 mt-4">
        <button className="w-full flex items-center justify-center space-x-2 p-3 rounded-xl bg-telegram-dark hover:bg-telegram-dark/80 active:bg-telegram-dark/60 transition-colors">
          <Edit3 className="w-4 h-4 text-telegram-secondary" />
          <span className="text-telegram-text font-medium">编辑个人资料</span>
        </button>
      </div>

      {/* 设置菜单 */}
      <div className="mt-6 px-4">
        <h3 className="text-xs font-semibold text-telegram-secondary uppercase tracking-wider mb-3 px-1">
          设置
        </h3>
        <div className="space-y-1">
          {settingsMenu.map((item) => {
            const IconComponent = item.icon
            return (
              <button
                key={item.id}
                className="w-full flex items-center justify-between p-4 rounded-xl bg-telegram-dark hover:bg-telegram-dark/80 active:bg-telegram-dark/60 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <IconComponent className="w-5 h-5 text-telegram-secondary" />
                  <span className="text-telegram-text">{item.label}</span>
                </div>
                <div className="flex items-center space-x-2">
                  {item.value && (
                    <span className="text-sm text-telegram-secondary">{item.value}</span>
                  )}
                  <ChevronRight className="w-5 h-5 text-telegram-secondary" />
                </div>
              </button>
            )
          })}
        </div>
      </div>

      {/* 其他选项 */}
      <div className="mt-6 px-4">
        <h3 className="text-xs font-semibold text-telegram-secondary uppercase tracking-wider mb-3 px-1">
          其他
        </h3>
        <div className="space-y-1">
          {otherOptions.map((item) => {
            const IconComponent = item.icon
            return (
              <button
                key={item.id}
                className="w-full flex items-center justify-between p-4 rounded-xl bg-telegram-dark hover:bg-telegram-dark/80 active:bg-telegram-dark/60 transition-colors"
              >
                <div className="flex items-center space-x-3">
                  <IconComponent className="w-5 h-5 text-telegram-secondary" />
                  <span className="text-telegram-text">{item.label}</span>
                </div>
                <ChevronRight className="w-5 h-5 text-telegram-secondary" />
              </button>
            )
          })}
        </div>
      </div>

      {/* 退出登录 */}
      <div className="mt-6 px-4 pb-8">
        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="w-full flex items-center justify-center space-x-2 p-4 rounded-xl bg-red-500/20 hover:bg-red-500/30 active:bg-red-500/40 transition-colors"
        >
          <LogOut className="w-5 h-5 text-red-400" />
          <span className="text-red-400 font-medium">退出登录</span>
        </button>
      </div>

      {/* 版本信息 */}
      <div className="text-center pb-4">
        <p className="text-xs text-telegram-secondary">版本 1.0.0 (Build 100)</p>
      </div>

      {/* 退出确认弹窗 */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 px-6">
          <div className="bg-telegram-dark rounded-2xl p-6 w-full max-w-sm">
            <h3 className="text-lg font-semibold text-telegram-text mb-2">确认退出？</h3>
            <p className="text-telegram-secondary mb-6">退出后需要重新登录才能使用全部功能</p>
            <div className="flex space-x-3">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="flex-1 py-3 rounded-xl bg-telegram-secondary/20 text-telegram-text font-medium hover:bg-telegram-secondary/30 transition-colors"
              >
                取消
              </button>
              <button
                onClick={() => {
                  setShowLogoutConfirm(false)
                  // 处理退出逻辑
                }}
                className="flex-1 py-3 rounded-xl bg-red-500 text-white font-medium hover:bg-red-600 transition-colors"
              >
                确认退出
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
